import { initContract } from '@ts-rest/core'
import { initQueryClient } from '@ts-rest/react-query'

import { createAppClientOptions } from './utils'

const c = initContract()

const routes = c.router({
    token: {
        method: 'GET',
        path: '/auth/token/',
        summary: 'Get JWT token to use in chat server',
        responses: {
            200: c.type<{ access_token: string; refresh_token: string }>(),
        },
    },
})

export const identityApi = initQueryClient(routes, createAppClientOptions('identity'))
